/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_pagination_product_visible_count = /** @type {(inputs: { current_product_count: NonNullable<unknown>, total_product_count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.current_product_count} z ${i.total_product_count} produktů`
};

const da_pagination_product_visible_count = /** @type {(inputs: { current_product_count: NonNullable<unknown>, total_product_count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.current_product_count} af ${i.total_product_count} produkter`
};

const de_pagination_product_visible_count = /** @type {(inputs: { current_product_count: NonNullable<unknown>, total_product_count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.current_product_count} von ${i.total_product_count} Produkten`
};

const en_pagination_product_visible_count = /** @type {(inputs: { current_product_count: NonNullable<unknown>, total_product_count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.current_product_count} of ${i.total_product_count} products`
};

const es_pagination_product_visible_count = /** @type {(inputs: { current_product_count: NonNullable<unknown>, total_product_count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.current_product_count} de ${i.total_product_count} productos`
};

const fr_pagination_product_visible_count = /** @type {(inputs: { current_product_count: NonNullable<unknown>, total_product_count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.current_product_count} sur ${i.total_product_count} produits`
};

const hu_pagination_product_visible_count = /** @type {(inputs: { current_product_count: NonNullable<unknown>, total_product_count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.current_product_count} / ${i.total_product_count} termék`
};

const it_pagination_product_visible_count = /** @type {(inputs: { current_product_count: NonNullable<unknown>, total_product_count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.current_product_count} su ${i.total_product_count} prodotti`
};

const nl_pagination_product_visible_count = /** @type {(inputs: { current_product_count: NonNullable<unknown>, total_product_count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.current_product_count} van ${i.total_product_count} producten`
};

const pl_pagination_product_visible_count = /** @type {(inputs: { current_product_count: NonNullable<unknown>, total_product_count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.current_product_count} z ${i.total_product_count} produktów`
};

const pt_pagination_product_visible_count = /** @type {(inputs: { current_product_count: NonNullable<unknown>, total_product_count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.current_product_count} de ${i.total_product_count} produtos`
};

const sv_pagination_product_visible_count = /** @type {(inputs: { current_product_count: NonNullable<unknown>, total_product_count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.current_product_count} av ${i.total_product_count} produkter`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ current_product_count: NonNullable<unknown>, total_product_count: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const pagination_product_visible_count = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pagination_product_visible_count(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("pagination_product_visible_count", locale)
	if (locale === "cs") return cs_pagination_product_visible_count(inputs)
	if (locale === "da") return da_pagination_product_visible_count(inputs)
	if (locale === "de") return de_pagination_product_visible_count(inputs)
	if (locale === "en") return en_pagination_product_visible_count(inputs)
	if (locale === "es") return es_pagination_product_visible_count(inputs)
	if (locale === "fr") return fr_pagination_product_visible_count(inputs)
	if (locale === "hu") return hu_pagination_product_visible_count(inputs)
	if (locale === "it") return it_pagination_product_visible_count(inputs)
	if (locale === "nl") return nl_pagination_product_visible_count(inputs)
	if (locale === "pl") return pl_pagination_product_visible_count(inputs)
	if (locale === "pt") return pt_pagination_product_visible_count(inputs)
	return sv_pagination_product_visible_count(inputs)
};
export { pagination_product_visible_count as "pagination.product_visible_count" }